import $ from 'jquery';
import _ from 'lodash';

/**
 * Global Util Functions
 *
 */
const Utils = {
  /**
    * Test if Obj is empty
    */
  objIsEmpty: (obj) => {
    if (typeof obj === 'object' && !(obj instanceof Array)) {
      if (Object.keys(obj).length === 0) return true;
    }
    return false;
  },

  /**
    * Convert Obj to Arr
    */
  objToArr: obj => Object.keys(obj).map(k => obj[k]),

  /**
    * Transform string to title case
    */  
  toTitleCase: (str) => {
    return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
  },

  joinObjectArray: (arr1, arr2) => {
    let newArr = [];

    arr1.map(function(arr) {
      newArr.push(arr);
    });

    arr2.map(function(arr) {
      newArr.push(arr);
    });

    return newArr;
  },

  infiniteScroll(callback) {
    $(window).on("scroll", function() {
      if ((window.innerHeight + window.scrollY) >= (document.body.offsetHeight * 0.70)) {
          callback()
      }
    });
  }
};

export default Utils;

export function downloadFile(urlToSend, filename="download"){
  let req = new XMLHttpRequest();
  req.open("GET", urlToSend, true);
  req.responseType = "blob";
  req.setRequestHeader('Authorization', localStorage.getItem("APN_AUTH_TKN"))
  req.onload = function (event) {
    let blob = req.response;
    let link=document.createElement('a');
    document.body.appendChild(link)
    link.download = filename;
    link.href=window.URL.createObjectURL(blob);
    link.click();
  };

  req.send();
}


// WEBPACK FOOTER //
// ./src/lib/utils.js